const EMAIL = 'email';
const PHONE = 'phone';
const UID = 'uid';

export { EMAIL, PHONE, UID };
